import { useEffect, useState } from 'react';
import api from '../services/ApiService';

// End-user Company Directory — colleagues with extensions, click-to-dial.
// Rendered inside AgentPortal (light theme). Visible to every phone user.
export default function DirectoryPanel({ onDial }: { onDial: (n: string) => void }) {
  const [rows, setRows] = useState<any[]>([]);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setRows((await api.getDirectory()) || []); }
      catch { /* ignore */ }
      finally { setLoading(false); }
    })();
  }, []);

  const nm = (d: any) => [d.first_name, d.last_name].filter(Boolean).join(' ') || d.display_name || d.username;
  const rowsF = rows.filter((d) =>
    !q.trim() || `${nm(d)} ${d.extension_number || ''} ${d.department || ''}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="page-content" style={{ overflowY: 'auto' }}>
      <div className="content-card">
        <div className="admin-page-title">Company Directory</div>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search colleagues…"
          style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #e5e7eb', margin: '10px 0 14px', fontSize: 14 }}
        />
        {loading && <div style={{ color: '#6b7280' }}>Loading…</div>}
        {!loading && rowsF.length === 0 && <div style={{ color: '#6b7280' }}>No colleagues found.</div>}
        <div style={{ display: 'grid', gap: 8 }}>
          {rowsF.map((d: any) => (
            <div key={d.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', border: '1px solid #eef1f6', borderRadius: 10, background: '#fff' }}>
              <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#eef2ff', color: '#4f46e5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 }}>
                {(nm(d)[0] || '?').toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nm(d)}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>
                  {[d.extension_number && `Ext ${d.extension_number}`, d.department, d.job_title].filter(Boolean).join(' · ') || '—'}
                </div>
              </div>
              {d.extension_number && (
                <button
                  onClick={() => onDial(String(d.extension_number))}
                  style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}
                >
                  Call
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
